/**
 * 📊 Sessions Analytics Dashboard
 * 
 * Dashboard unificado con tabs para:
 * - Zombie Sessions: sesiones pausadas sin resolver
 * - Normal Sessions: sesiones activas, completadas, abandonadas
 */

import React, { useState } from 'react';
import { AlertTriangle, Activity } from 'lucide-react';
import ZombieSessionsPanel from './ZombieSessionsPanel';
import NormalSessionsPanel from './NormalSessionsPanel';

const SessionsAnalyticsDashboard = () => {
  const [activeTab, setActiveTab] = useState('zombie'); // 'zombie' | 'normal'
  
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header con Tabs */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6">
          <div className="flex border-b border-gray-200">
            {/* Tab Zombie Sessions */}
            <button
              onClick={() => setActiveTab('zombie')}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors ${
                activeTab === 'zombie'
                  ? 'border-b-2 border-red-500 text-red-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <AlertTriangle className="w-5 h-5" />
              Zombie Sessions
              <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                activeTab === 'zombie'
                  ? 'bg-red-100 text-red-700'
                  : 'bg-gray-100 text-gray-600'
              }`}>
                Alertas
              </span>
            </button>
            
            {/* Tab Normal Sessions */}
            <button
              onClick={() => setActiveTab('normal')}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors ${
                activeTab === 'normal'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <Activity className="w-5 h-5" />
              Normal Sessions
              <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                activeTab === 'normal'
                  ? 'bg-blue-100 text-blue-700'
                  : 'bg-gray-100 text-gray-600'
              }`}>
                Observabilidad
              </span>
            </button>
          </div>
        </div>
        
        {/* Content */}
        <div>
          {activeTab === 'zombie' && <ZombieSessionsPanel />}
          {activeTab === 'normal' && <NormalSessionsPanel />}
        </div>
      </div>
    </div>
  );
};

export default SessionsAnalyticsDashboard;
